import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import CampaignSend         from "./CampaignSend";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import ConfirmDialog        from "dashboard/dist/Components/ConfirmDialog";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";

// Actions
import {
    fetchCampaigns, pauseCampaign, deleteCampaign,
} from "Actions/Admin/Campaign/CampaignActions";



/**
 * The Campaign List
 */
class CampaignList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=}  params
     * @param {Boolean=} withLoader
     * @returns {Void}
     */
    fetch = (params, withLoader) => {
        this.props.fetchCampaigns(params || this.props.data.sort, withLoader);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }

    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch(null, false);
    }

    /**
     * Returns true if it can Edit the Campaign
     * @param {Number} elemID
     * @returns {Boolean}
     */
    canEdit(elemID) {
        const { list, canEdit } = this.props.data;
        return canEdit && Utils.getValue(list, "campaignID", elemID).canEdit;
    }

    /**
     * Handles the Pause Submit
     * @returns {Promise}
     */
    pauseElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.pauseCampaign(elemID);
        this.fetch(null, false);
    }

    /**
     * Returns true if it can Pause the Campaign
     * @param {Number} elemID
     * @returns {Boolean}
     */
    canPause(elemID) {
        const { list, canEdit } = this.props.data;
        return canEdit && Utils.getValue(list, "campaignID", elemID).canPause;
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.deleteCampaign(elemID);
        this.fetch(null, false);
    }

    /**
     * Returns true if it can Delete the Campaign
     * @param {Number} elemID
     * @returns {Boolean}
     */
    canDelete(elemID) {
        const { list, canEdit } = this.props.data;
        return canEdit && Utils.getValue(list, "campaignID", elemID).canDelete;
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                      } = this.state;
        const { data, route                         } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        const elemName = Utils.getValue(list, "campaignID", elemID, "subject");

        return <Main>
            <Header message="CAMPAIGNS_NAME" icon="campaign" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="CAMPAIGNS_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="subject"      message="CAMPAIGNS_SUBJECT"   />
                        <TableHeader field="templateName" message="CAMPAIGNS_TEMPLATE"  />
                        <TableHeader field="totalUsers"   message="USERS_NAME"          maxWidth="80"  align="center" />
                        <TableHeader field="state"        message="GENERAL_STATUS"      maxWidth="100" noSorting />
                        <TableHeader field="sentTime"     message="GENERAL_SENT_AT_FEM" maxWidth="160" />
                        <TableHeader field="createdTime"  message="GENERAL_CREATED_FEM" maxWidth="90"  hideMobile />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.campaignID} elemID={elem.campaignID}>
                            <TableCell message={elem.subject}      />
                            <TableCell message={elem.templateName} />
                            <TableCell message={elem.totalUsers}   />
                            <TableCell message={elem.stateName}    className={elem.stateClass} />
                            <TableCell message={elem.sentDateTime} />
                            <TableCell message={elem.createdDate}  />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="VIEW"   message="CAMPAIGNS_VIEW_TITLE"   route={route} />
                        <TableAction action="EDIT"   message="CAMPAIGNS_EDIT_TITLE"   hide={(elemID) => !this.canEdit(elemID)} />
                        <TableAction action="CANCEL" message="CAMPAIGNS_PAUSE_TITLE"  hide={(elemID) => !this.canPause(elemID)} />
                        <TableAction action="DELETE" message="CAMPAIGNS_DELETE_TITLE" hide={(elemID) => !this.canDelete(elemID)} />
                        <TableAction action="SEND"   message="CAMPAIGNS_RESEND_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <CampaignSend
                open={action.isCE || action.isSend}
                elemID={elemID}
                isCopy={action.isSend}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <ConfirmDialog
                open={action.isCancel}
                icon="cancel"
                title="CAMPAIGNS_PAUSE_TITLE"
                message="CAMPAIGNS_PAUSE_TEXT"
                primary="GENERAL_CANCEL"
                content={elemName}
                onSubmit={this.pauseElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="CAMPAIGNS_DELETE_TITLE"
                message="CAMPAIGNS_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchCampaigns : PropTypes.func.isRequired,
        pauseCampaign  : PropTypes.func.isRequired,
        deleteCampaign : PropTypes.func.isRequired,
        data           : PropTypes.object.isRequired,
        route          : PropTypes.string.isRequired,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.campaign,
        };
    }
}

export default connect(CampaignList.mapStateToProps, {
    fetchCampaigns, pauseCampaign, deleteCampaign,
})(CampaignList);
